var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("default",null,{"on":on,"attrs":attrs})]}}],null,true)},[_c('v-card',{attrs:{"width":"300"}},_vm._l((_vm.icons),function(icon,index){return _c('v-btn',{key:index,attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('input', icon)}}},[_c('span',{staticStyle:{"font-size":"2em"}},[_vm._v(_vm._s(icon))])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }